import axiosClient from "../../../../../../api/axiosClient";

export async function fetchStockRegister(filters) {

  const params = {
    from_date: filters.fromDate,
    to_date: filters.toDate,
    material_id: filters.material || undefined,
    warehouse_id: filters.warehouse || undefined,
    batch_no: filters.batch || undefined
  };

  const res = await axiosClient.get(
    "/api/ppe/material-flow/inventory/reports/stock-register",
    { params }
  );

  return res.data.data;
}

export async function exportStockRegisterExcel(filters) {

  const params = {
    from_date: filters.fromDate,
    to_date: filters.toDate,
    material_id: filters.material || undefined,
    warehouse_id: filters.warehouse || undefined,
    batch_no: filters.batch || undefined
  };

  const response = await axiosClient.get(
    "/api/ppe/material-flow/inventory/reports/stock-register/excel",
    {
      params,
      responseType: "blob"
    }
  );

  return response.data;
}